export const isUserMatch = (currentUserId, createdByUserId) => {
    if (!currentUserId || !createdByUserId) {
        return false;
    }
    return currentUserId === createdByUserId;
};
